import React from 'react'
import './AddQualifications.scss'
import CustomStepper from '../CustomStepper/CustomStepper'
const AddQualifications: React.FC = () => {
    return(
        <div className="page add-qualifications">
            <CustomStepper/>
        </div>
    )
}

export default AddQualifications